import React from 'react';
import { Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import MaterialTable from 'material-table';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {getAdmins} from '../dashboard/dashboard.actions';
import moment from 'moment'
import {deleteAdmin, updateAdmin, selectedAdmin, addAdmin} from './admin.actions';

function Admin(props) {
  const adminsData= props.admins;
  const [state, setState] = React.useState({
    columns: [
      { title: 'First Name', field: 'first_name' },
      { title: 'Last Name', field: 'last_name' },
      { title: 'Email', field: 'email', editable: 'onAdd' },
      { title: 'Created At', field: 'createdAt',  render: rowData => moment(rowData.date_created).format('MM-DD-YYYY'), type: 'date',  editable: 'onAdd' },
      { title: 'Password', field: 'password',  render: rowData =>   'XXX'  }
    ]
  });
  const [callEdit, setcallEdit] = React.useState(false);
  if (callEdit) {
    return <Redirect push to="/View Admin" />;
  }

  return (
    <MaterialTable
      title="Admin"
      columns={state.columns}
      data={adminsData}
      actions={[
        {
          icon: VisibilityIcon,
          tooltip: 'View Admin',
          onClick: (event, rowData) => {
            // Do save operation
            setcallEdit(true);
           
            props.viewSelectedAdmin(rowData);
          }
        }
      ]}
      options={{
        actionsColumnIndex: -1,
        headerStyle: { position: 'sticky', top: 0,
          color: '#00BBBB',
          fontWeight: '550',
        }
      }}
      editable={{
        onRowAdd: (newData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              props.addAdminFunction(newData)
            }, 600);
          }),
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              if (oldData) {
                props.updateAdminFunction(newData, oldData)
              }
            }, 600);
          }),
        onRowDelete: (oldData) =>
        new Promise((resolve) => {
          setTimeout(() => {
            resolve();
            props.deleteAdminFunction(oldData.admin_user_id);
          }, 600);
        }),
      }}
    />
  );
}
const mapDispatchToProps = dispatch => {
  return {
    // dispatching plain actions
    getAdmins: () => dispatch(getAdmins()),
    deleteAdminFunction: (id) => dispatch(deleteAdmin(id)),
    updateAdminFunction: (data, oldData) => dispatch(updateAdmin(data, oldData)),
    viewSelectedAdmin: (data) => dispatch(selectedAdmin(data)),
    addAdminFunction: (data) => dispatch(addAdmin(data)),
  }
}

const mapStateToProps =(state, ownProps, number)  =>({
      admins : state.dashboardReducer.admins,
      adminDeleted: state.adminReducer.adminDeleted
    })

export default connect(mapStateToProps,mapDispatchToProps)(Admin);
